let videos = {
    changeMachineTreatmentMode: {
        embedId: '_adZbh8QisQ',
        nameKey: 'changeMachineTreatmentMode',
        imageName: 'changeMachineTreatmentMode.jpg'
    },
    staffPerformanceAnalysis: {
        embedId: 'd02pZdfdaYA',
        nameKey: 'staffPerformanceAnalysis',
        imageName: 'staffPerformanceAnalysis.jpg'
    },
    smartClinicCrashCourse: {
        embedId: '5jrX6jb2ebM',
        nameKey: 'smartClinicCrashCourse',
        imageName: 'smartClinicCrashCourse.jpg'
    },
    notificationsAndAlerts: {
        embedId: '-XtjGJwjP-o',
        nameKey: 'notificationsAndAlerts',
        imageName: 'notificationsAndAlerts.jpg'
    },
    editPatientDetails: {
        embedId: 'PO_DzkXFDA8',
        nameKey: 'editPatientDetails',
        imageName: 'editPatientDetails.jpg'
    },
    addNewStaffMembers: {
        embedId: '7XjS4D2C7bc',
        nameKey: 'addNewStaffMembers',
        imageName: 'addNewStaffMembers.jpg'
    },
    editAccountDetails: {
        embedId: '9vNUQjxVHD4',
        nameKey: 'editAccountDetails',
        imageName: 'editAccountDetails.jpg'
    },
    connectADevice: {
        embedId: 'k0mNoPmG8BA',
        nameKey: 'connectADevice',
        imageName: 'connectADevice.jpg'
    },
}

export default videos;
